import { Component, DestroyRef, QueryList, ViewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asapScheduler, observeOn } from 'rxjs';
import { CfetBaseComponent, CfetService, AdobeAnalyticsService, CfetNavigationDirective } from './../../cfet-core';
import 'element-closest-polyfill';

@Component({
    selector: 'app-utf-nav-header',
    templateUrl: './utf-nav-header.component.html',
    styleUrls: ['./utf-nav-header.component.scss'],
    standalone: false
})
export class UtfNavHeaderComponent extends CfetBaseComponent  {
  isLandingPage: boolean;
  trapFocusForCato: boolean;
  @ViewChildren(CfetNavigationDirective) inputs: QueryList<CfetNavigationDirective>;

  constructor(private adobeAnalyticsService: AdobeAnalyticsService,
    private destroyRef: DestroyRef,
    private cfetService: CfetService) {
    super();
    this.cfetService.isLandingPage.pipe(
      observeOn(asapScheduler),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((flag) => {
      this.isLandingPage = flag;
    });
    this.cfetService.trapFocus.pipe(
      observeOn(asapScheduler),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((flag) => {
      this.trapFocusForCato = flag;
    });
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method

  adobeLinkClick (linkName, destUrl, path, position?: any) {
    const eventData = {
      eventAction: 'linkClick',
      eventCode: 'Link_Click',
      objData: {
        linkName: linkName,
        linkPosition: position ? position : 'GlobalNavTopBar',
        linkDestinationUrl: `${window.location.host}${destUrl}`,
        linkPath: path ? path : '',
        supmethod: 'OT'
      }
    };
    this.adobeAnalyticsService.pushToDatalayerPushEvent(eventData.eventAction, eventData.eventCode, eventData.objData);
  }

}

